export default __webpack_public_path__ + "static/Semi-TruckAccident-597509c3662a3fbe3d180348ff2fe510.svg";